export default "/storefront/client/images/imageNotFound.png";